import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CardMenuModule } from '../card-menu/card-menu.module';
import { HomeComponent } from './home.component';
import { AreaRestritaSharedModule } from '../shared/area-restitra.shared.module';
import { HomeService } from './service/home.service';

@NgModule({
  imports: [
    CommonModule,
    AreaRestritaSharedModule,
    CardMenuModule
  ],
  declarations: [
    HomeComponent
  ],
  exports: [
    HomeComponent
  ],
  providers: [
    HomeService
  ]
})
export class HomeModule { }



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/home/home.module.ts